import { SecurityProfile } from './security-profile.model';

/**
 * A userProfile response may arrive bare, or wrapped in `{ data }` / `{ Data }`
 * depending on the API's casing. Unwrap to the inner SecurityProfile.
 */
export function unwrapSecurityProfile(
  x: SecurityProfile | { data?: SecurityProfile; Data?: SecurityProfile }
): SecurityProfile {
  const wrapped = x as { data?: SecurityProfile; Data?: SecurityProfile };
  return (wrapped?.data ?? wrapped?.Data ?? x) as SecurityProfile;
}
